import script from "./TextBlockIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBlockIcon.vue?vue&type=script&setup=true&lang=js"

import "./TextBlockIcon.vue?vue&type=style&index=0&id=6d06c50d&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d06c50d"]])

export default __exports__